// extracted by mini-css-extract-plugin
export default {"loaderDimmer":"Loader_loaderDimmer__CyaSQ"};